import React from "react";
import { CircularProgress } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() =>
  createStyles({
    circle: {
      position: "absolute",
      right: 0,
      width: "20px !important",
      height: "20px !important",
      marginInline: 10,
    },
  })
);

const CircleLoader = () => {
  const classes = useStyles();
  return <CircularProgress className={classes.circle} color="secondary" />;
};

export default CircleLoader;
